export default __webpack_public_path__ + "static/media/four.dff6f605.png";